import { useTranslation } from 'react-i18next'

import { useInitData, useLinkLikeClick } from '../../../../../hooks'
import { getRequestProfilePathname } from '../../../../../utils/link'
import Button from '../../../../Button'

import { QA_NAME_VIEW_REQUEST_BUTTON } from './NewsboardRequestTypeFooter.constants'

function NewsboardRequestTypeFooter({ data }) {
  const { t } = useTranslation()

  const { handleClick: handleLinkLikeClick } = useLinkLikeClick()

  const { availableSections } = useInitData()

  const requestId = data.requests?.[0]?.id

  function handleClick() {
    handleLinkLikeClick({
      link: getRequestProfilePathname({ availableSections, id: requestId }),
    })
  }

  return requestId ? (
    <Button.Contained
      qaName={QA_NAME_VIEW_REQUEST_BUTTON}
      text={t('Newsboard.ViewRequestActionKey')}
      onClick={handleClick}
    />
  ) : null
}

export default NewsboardRequestTypeFooter
